import type { AuthUser } from './types'

export function isAdminUser(user: AuthUser | null | undefined): boolean {
  return user?.role === 'ADMIN'
}
